import { useT } from "../lib/i18n.jsx";

/** Sparkle glyph for the AI assistant (item 0325). Inline, no icon set. */
export function SparkGlyph({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" fill="currentColor">
      <path d="M12 2.5l1.9 5.6 5.6 1.9-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.9z" />
      <path d="M18.5 14.5l.9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9z" />
    </svg>
  );
}

/** Opens the assistant. Above phone width it is a labelled pill in the
 *  bottom-right dock, left of "Open on your phone" (ViewerPage); on a phone,
 *  a round button in the left control column, like the QR button. Only
 *  rendered when the venue has switched the assistant on. */
export default function AssistantButton({ compact = false, onClick }) {
  const { t } = useT();
  if (compact) {
    return (
      <button
        data-assistant-button
        onClick={onClick}
        aria-label={t("assistant_button")}
        title={t("assistant_button")}
        className="flex h-10 w-10 items-center justify-center rounded-full bg-[#e63946] text-white shadow-md"
      >
        <SparkGlyph size={20} />
      </button>
    );
  }
  return (
    <button
      data-assistant-button
      onClick={onClick}
      className="flex h-12 items-center gap-2 rounded-xl bg-[#e63946] px-4 text-sm font-semibold
                 text-white shadow-lg active:bg-[#c92e3b]"
    >
      <SparkGlyph size={20} />
      <span className="whitespace-nowrap">{t("assistant_button")}</span>
    </button>
  );
}
